import { LockedCard } from "@/features/cards/templates/LockedCard";

export const CARD_TEMPLATES = [
  { id: "card_01", name: "Premium Dark" },
  { id: "card_02", name: "Premium Light" },
  { id: "card_03", name: "Midnight" },
  { id: "card_04", name: "Architectural" },
  { id: "card_05", name: "Signature" },
];

export const DEFAULT_TEMPLATE_ID = "card_01";
export const CARD_DESIGN_VERSION = 2;
const IDS = new Set(CARD_TEMPLATES.map((t) => t.id));
export const getTemplate = (id) => CARD_TEMPLATES.find((t) => t.id === (IDS.has(id) ? id : DEFAULT_TEMPLATE_ID));

// Background is implied by template_id; design_config only carries the composition version.
export const normalizeDesignConfig = () => ({ version: CARD_DESIGN_VERSION });

export function CardRenderer({ templateId, identity, idPrefix }) {
  return <LockedCard templateId={getTemplate(templateId).id} identity={identity} idPrefix={idPrefix} />;
}
